const tending = [
  {
    id: 1,
    imgUrl: "/images/media1.png",
    altText: "Alt Text",
    title: "Essentials: Inside the Curve",
    subtext: "Dave Kitman",
  },
  {
    id: 2,
    imgUrl: "/images/media2.png",
    altText: "Alt Text",
    title: "How to start a Podcast Business",
    subtext: "Hofeler & Co",
  },
  {
    id: 3,
    imgUrl: "/images/media3.png",
    altText: "Alt Text",
    title: "Dazed & Confused",
    subtext: "Butler & Stefens",
  },
  {
    id: 4,
    imgUrl: "/images/media4.png",
    altText: "Alt Text",
    title: "Jigsaw Falling into Place",
    subtext: "Dave Ramsey",
  },
  {
    id: 5,
    imgUrl: "/images/media3.png",
    altText: "Alt Text",
    title: "Dazed & Confused",
    subtext: "Butler & Stefens",
  },
];

export function getTending() {
  return tending;
}
